import {gql} from "apollo-angular";
import {institutionServiceFields} from "../service/service.graphql";
import {baseResponseGraphqlField} from "../../../base.graphql";


export const GET_REQUESTED_CHANGE_SERVICES = gql`
  query GetRequestedServices($institutionUniqueId: String!) {
    getRequestedServices(institutionUniqueId: $institutionUniqueId) {
      ${baseResponseGraphqlField}
      data {
        ${institutionServiceFields}
      }
    }
  }
`


